<template>
  <base-dialog v-if="categoryExists" :model-value="true" @keydown.esc="closeDialog" size="small">
    <v-card-item>
      <v-card-title>
        <span class="text-h5" data-test-id="title">{{ mode === "add" ? "Add" : "Edit" }} Category</span>
      </v-card-title>
    </v-card-item>
    <v-card-text>
      <v-form ref="form" v-model="formValid" @submit.prevent="saveDialog">
        <v-row>
          <v-col cols="12">
            <v-text-field label="Name" v-model="name" data-test-id="name" autofocus required :rules="nameRules" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <ColorSelector :colors="colors" v-model="color" />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <cancel-btn @click="closeDialog">Close</cancel-btn>
      <submit-btn type="submit" @click="saveDialog">Save</submit-btn>
    </v-card-actions>
  </base-dialog>
</template>

<script>
import { ref } from "vue"
import { useRouter } from "vue-router"

import { useCategory } from "../use"
import { useNotification } from "@/modules/notification/use"

import ColorSelector from "@/components/ColorSelector"
import colors from "../colors"

export default {
  name: "EditCategoryView",
  props: {
    categoryId: {
      type: String,
      required: true,
    },
  },
  components: {
    ColorSelector,
  },
  setup(props) {
    let router = useRouter()

    let bp_category = useCategory()

    let mode = props.categoryId === "new" ? "add" : "edit"

    const form = ref(null)
    let formValid = ref(false)
    let nameRules = [(v) => !!v || "Name is required."]

    let name = ref(null)
    let color = ref(colors[0])

    if (mode === "edit") {
      let category = bp_category.getById(props.categoryId)

      if (category === undefined || category === null) {
        // we may have lost it via LiveUpdate, and we do a browser refresh?
        let bp_notification = useNotification()
        bp_notification.show({
          type: "error",
          message: "That category no longer exists",
        })
        router.push({ name: "categories-show" })
        return {
          categoryExists: false,
        }
      }

      name.value = category.name
      color.value = category.color
    }

    const closeDialog = () => {
      router.push({ name: "categories-show" })
    }

    const saveDialog = () => {
      form.value.validate()

      if (formValid.value || formValid.value === null) {
        // HACK: first time the value might be null? Bug?
        if (mode === "edit") {
          bp_category.update({ categoryId: props.categoryId, name: name.value, color: color.value })
        } else {
          bp_category.add({ name: name.value, color: color.value })
        }
        closeDialog()
      }
    }

    return {
      categoryExists: true,
      form,
      formValid,
      nameRules,
      closeDialog,
      saveDialog,
      name,
      color,
      colors,
      mode,
    }
  },
}
</script>

<style lang="scss" scoped></style>
